import "./Home.scss";
import { useMemo, useState } from "react";
import { useNavigate } from "react-router-dom";

import acer_default from "../assets/images/acer_default.jpg";
import acer_default1 from "../assets/images/acer_default1.jpg";
import acer_default2 from "../assets/images/acer_default2.jpg";
import acer_default2b from "../assets/images/acer_default2b.jpg";
import acer_default3 from "../assets/images/acer_default3.jpg";
import acer_default4 from "../assets/images/acer_default4.jpg";
import acer_default5 from "../assets/images/acer_default5.jpg";

import lenovo_default from "../assets/images/lenovo_default.jpg";
import lenovo_default1 from "../assets/images/lenovo_default1.jpg";
import lenovo_default2 from "../assets/images/lenovo_default2.jpg";
import lenovo_default3 from "../assets/images/lenovo_default3.jpg";
import lenovo_default4 from "../assets/images/lenovo_default4.jpg";
import lenovo_default5 from "../assets/images/lenovo_default5.jpg";
import lenovo_default6 from "../assets/images/lenovo_default6.jpg";
import lenovo_default7 from "../assets/images/lenovo_default7.jpg";

import asus_default from "../assets/images/asus_default.jpg";
import asus_default1 from "../assets/images/asus_default1.jpg";
import asus_default2 from "../assets/images/asus_default2.jpg";
import asus_default3 from "../assets/images/asus_default3.jpg";
import asus_default4 from "../assets/images/asus_default4.jpg";
import asus_default5 from "../assets/images/asus_default5.jpg";
import asus_default6 from "../assets/images/asus_default6.jpg";
import asus_default7 from "../assets/images/asus_default7.jpg";
import asus_default8 from "../assets/images/asus_default8.jpg";

import msi_default from "../assets/images/msi_default.jpg";
import msi_default1 from "../assets/images/msi_default1.jpg";
import msi_default2 from "../assets/images/msi_default2.jpg";
import msi_default3 from "../assets/images/msi_default3.jpg";
import msi_default4 from "../assets/images/msi_default4.jpg";
import msi_default5 from "../assets/images/msi_default5.jpg";
import msi_default6 from "../assets/images/msi_default6.jpg";
import msi_default7 from "../assets/images/msi_default7.jpg";
import msi_default8 from "../assets/images/msi_default8.jpg";

import hp_default from "../assets/images/hp_default.jpg";
import hp_default1 from "../assets/images/hp_default1.jpg";
import hp_default2 from "../assets/images/hp_default2.jpg";
import hp_default3 from "../assets/images/hp_default3.jpg";
import hp_default4 from "../assets/images/hp_default4.jpg";
import hp_default5 from "../assets/images/hp_default5.jpg";
import hp_default6 from "../assets/images/hp_default6.jpg";
import hp_default7 from "../assets/images/hp_default7.jpg";
import hp_default8 from "../assets/images/hp_default8.jpg";

import dell_default from "../assets/images/dell_default.jpg";
import dell_default1 from "../assets/images/dell_default1.jpg";
import dell_default2 from "../assets/images/dell_default2.jpg";
import dell_default3 from "../assets/images/dell_default3.jpg";
import dell_default4 from "../assets/images/dell_default4.jpg";
import dell_default5 from "../assets/images/dell_default5.jpg";
import dell_default6 from "../assets/images/dell_default6.jpg";
import dell_default7 from "../assets/images/dell_default7.jpg";
import dell_default8 from "../assets/images/dell_default8.jpg";

import apple_default from "../assets/images/apple_default.jpg";
import apple_default1 from "../assets/images/apple_default1.jpg";
import apple_default2 from "../assets/images/apple_default2.jpg";
import apple_default3 from "../assets/images/apple_default3.jpg";
import apple_default4 from "../assets/images/apple_default4.jpg";
import apple_default5 from "../assets/images/apple_default5.jpg";
import apple_default6 from "../assets/images/apple_default6.jpg";
import apple_default7 from "../assets/images/apple_default7.jpg";
import apple_default8 from "../assets/images/apple_default8.jpg";

import acerBanner from "../assets/images/banner_acer.jpg";
import lenovoBanner from "../assets/images/banner_lenovo.jpg";
import asusBanner from "../assets/images/banner_asus.jpg";
import msiBanner from "../assets/images/banner_msi.jpg";
import hpBanner from "../assets/images/banner_hp.jpg";
import dellBanner from "../assets/images/banner_dell.png";
import appleBanner from "../assets/images/banner_apple.jpg";
import { lowerCase } from "lodash";


type Product = {
  id: number;
  imgSrc: string;
  title: string;
  price: string;
  badge?: string;
};

type CartItem = Product & {
  quantity: number;
};

type BrandSection = {
  key: string;
  title: string;
  banner: string;
  products: Product[];
};

type ProductCardProps = {
  product: Product;
  onAddToCart: (product: Product) => void;
};

type BrandShowcaseProps = {
  section: BrandSection;
  bannerLeft?: boolean;
  onAddToCart: (product: Product) => void;
};

const ITEMS_PER_PAGE = 3;

function ProductCard({ product, onAddToCart}: ProductCardProps) {
  return (
    <article className="brand-product-card">
      <div className="brand-product-thumb">
        {product.badge && <span className="brand-product-badge">{product.badge}</span>}
        <img src={product.imgSrc} alt={product.title} />
      </div>

      <div className="brand-product-body">
        <h3 title={product.title}>{product.title}</h3>

        <div className="brand-product-cta">
          <span className="brand-product-price">{product.price}</span>
          <button type="button" className="brand-product-add-cart" 
            onClick={() => onAddToCart(product)}>
            <i className="fa-solid fa-cart-shopping" aria-hidden="true"></i>
            Add to Cart
          </button>
        </div>
      </div>
    </article>
  );
}

function BrandShowcase({ section, bannerLeft = false, onAddToCart }: BrandShowcaseProps) {
  const [page, setPage] = useState(0);

  const pages = useMemo(() => {
    const result: Product[][] = [];
    for (let i = 0; i < section.products.length; i += ITEMS_PER_PAGE) {
      result.push(section.products.slice(i, i + ITEMS_PER_PAGE));
    }
    return result;
  }, [section.products]);

  const visibleProducts = pages[page] ?? [];

  return (
    <section 
      id={`featured-products-` + lowerCase(section.title)}
      className={`brand-showcase-section ${bannerLeft ? "banner-left" : "banner-right"}`}
    >
      <aside className="brand-showcase-banner">
        <a href="#main-categories" aria-label={`${section.title} banner`}>
          <img src={section.banner} alt={`${section.title} promotional banner`} />
        </a>
      </aside>

      <div className="brand-showcase-main">
        <div className="brand-showcase-header">
          <h2>{section.title}</h2>
        </div>

        <div className="brand-showcase-products">
          {visibleProducts.map((product) => (
            <ProductCard key={`${section.key}-${product.id}`} product={product}
              onAddToCart={onAddToCart} />
          ))}
        </div>

        {pages.length > 1 && (
          <div className="brand-showcase-dots" aria-label={`${section.title} pagination`}>
            {pages.map((_, index) => (
              <button
                key={`${section.key}-dot-${index}`}
                type="button"
                className={`brand-showcase-dot ${page === index ? "active" : ""}`}
                onClick={() => setPage(index)}
                aria-label={`Go to ${section.title} page ${index + 1}`}
              />
            ))}
          </div>
        )}
      </div>
    </section>
  );
}

function HomeContent1() {
  const navigate = useNavigate();
  const [cartItems, setCartItems] = useState<CartItem[]>(() => {
    const saved = localStorage.getItem("cartItems");
    return saved ? JSON.parse(saved) : [];
  });

  const handleAddToCart = (product: Product) => {
    setCartItems((prev) => {
      const existing = prev.find((item) => item.id === product.id);

      let updated: CartItem[];

      if (existing) {
        updated = prev.map((item) =>
          item.id === product.id
            ? { ...item, quantity: item.quantity + 1 }
            : item
        );
      } else {
        updated = [...prev, { ...product, quantity: 1 }];
      }

      localStorage.setItem("cartItems", JSON.stringify(updated));
      return updated;
    });
  };

  const cartCount = cartItems.reduce((sum, item) => sum + item.quantity, 0);

  const acer: Product[] = [
    {
      id: 101,
      imgSrc: acer_default,
      title: 'Acer Aspire Lite 15 AL15-32P-C6X3 15.6" FHD Laptop Pure Silver ( N4500, 8GB, 512GB SSD, Intel, W11, HS+M365 )',
      price: "RM 1,529",
      badge: "New",
    },
    {
      id: 102,
      imgSrc: acer_default1,
      title: 'Acer Aspire Lite 15 AL15-46P-R8LD 15.6" FHD Laptop Light Silver ( R3-5400U, 8GB, 512GB SSD, ATI, W11, HS+M365 )',
      price: "RM 1,739",
    },
    {
      id: 103,
      imgSrc: acer_default2,
      title: 'Acer Aspire Lite 15 AL15-42P-R4FV 15.6" FHD Laptop Pure Silver ( R7-7730U, 16GB, 512GB SSD, ATI, W11, HS+M365 )',
      price: "RM 2,369",
      badge: "Hot",
    },
    {
      id: 104,
      imgSrc: acer_default2,
      title: 'Acer Aspire Lite 16 AL16-53P-55WM 16" WUXGA Laptop Pure Silver ( CU5-115U, 16GB, 512GB SSD, Intel, W11, HS+M365 )',
      price: "RM 2,469",
    },
    {
      id: 105,
      imgSrc: acer_default2b,
      title: 'Acer Swift Go 14 SFG14-72T-76T6 14" WUXGA Touch Laptop Pure Silver  ( CU7-155H, 16GB, 1TB SSD, Intel Arc, W11, HS+M365 )',
      price: "RM 4,999",
      badge: "Featured",
    },
    {
      id: 106,
      imgSrc: acer_default3,
      title: 'Acer Nitro V 15 ANV15-41-R0DZ 15.6" FHD 165Hz Gaming Laptop (R5 6600H, 8GB, 512GB SSD, RTX 3050 6GB, W11, HS+M365 )',
      price: "RM 2,839",
    },
    {
      id: 107,
      imgSrc: acer_default4,
      title: 'Acer Nitro V16s AI ANV16S-41-R9W8 16" WUXGA 180Hz Laptop (NVIDIA® GeForce RTX™ 5060, R7-260, 16GB, 1TB SSD, W11, HS)',
      price: "RM 5,619",
    },
    {
      id: 108,
      imgSrc: acer_default3,
      title: 'Acer Nitro V 15 ANV15-52-50XL 15.6" FHD 165Hz Gaming Laptop (C5-210H, 16GB, 512GB SSD, RTX3050 6GB, W11, HS+M365)',
      price: "RM 3,309",
    },
    {
      id: 109,
      imgSrc: acer_default5,
      title: 'Acer Predator Triton 14 Ai PT14-52T-93NP 14.5" WQXGA 120Hz Laptop (NVIDIA® GeForce RTX™ 5070, CU9 288V, 32GB, 2TB, W11, HS)',
      price: "RM 12,029",
    },
  ];

  const lenovo: Product[] = [
    {
      id: 110,
      imgSrc: lenovo_default,
      title: 'Lenovo ThinkPad E14 Gen 7 21T0005QMA 14" WUXGA Laptop Black ( R5-220, 16GB, 512GB SSD, ATI, W11P )',
      price: "RM 3,469",
    },
    {
      id: 111,
      imgSrc: lenovo_default1,
      title: 'Lenovo Legion 5 15IAX10 83F0008QMJ 15.1" WQXGA 165Hz Gaming Laptop Eclipse Black ( CU9-275HX, 32GB, 1TB SSD, RTX 5070 8GB, W11 )',
      price: "RM 8,349",
      badge: "On Sale",
    },
    {
      id: 112,
      imgSrc: lenovo_default1,
      title: 'Lenovo Legion 5 15IAX10 83F0008RMJ 15.1" WQXGA 165Hz Gaming Laptop Eclipse Black ( CU7-255HX, 16GB, 1TB SSD, RTX 5060 8GB, W11 )',
      price: "RM 6,939",
    },
    {
      id: 113,
      imgSrc: lenovo_default2,
      title: 'Lenovo Legion Pro 7 16IAX10H 83F500JEMJ 16" WQXGA 240Hz Gaming Laptop ( CU9-275HX, 32GB, 1TB SSD, RTX5070Ti 12GB, W11 )',
      price: "RM 13,339",
      badge: "Popular",
    },
    {
      id: 114,
      imgSrc: lenovo_default3,
      title: 'Lenovo IdeaPad 1 15AMN7 82VG00YDMJ 15.6" HD Laptop Cloud Grey ( Athlon 7120U, 8GB, 512GB SSD, ATI, W11, HS+M365 )',
      price: "RM 1,609",
    },
    {
      id: 115,
      imgSrc: lenovo_default4,
      title: 'Lenovo Yoga 7 14IML9 83DJ00JPMJ 14" WUXGA OLED 2-in-1 Touch Laptop Tidal Teal ( CU5 125H, 16GB, 512GB SSD, Intel, W11, HS+M365 )',
      price: "RM 3,629",
    },
    {
      id: 116,
      imgSrc: lenovo_default5,
      title: 'Lenovo LOQ 15AHP10 83JG00AVMJ 15.6" FHD 144Hz Gaming Laptop Luna Grey ( R7-250, 16GB, 512GB SSD, RTX5060 8GB, W11, HS )',
      price: "RM 4,839",
    },
    {
      id: 117,
      imgSrc: lenovo_default6,
      title: 'Lenovo IdeaPad Slim 3 15IAN8 82XB00J1MJ 15.6" FHD Laptop Arctic Grey ( N100, 8GB, 512GB SSD, Intel, W11, HS+M365 )',
      price: "RM 1,519",
    },
    {
      id: 118,
      imgSrc: lenovo_default7,
      title: 'Lenovo IdeaPad Slim 3 15IRU8 82X700KCMJ 15.6" FHD Laptop Abyss Blue (U300, 8GB, 512GB SSD, Intel, W11, HS+M365 )',
      price: "RM 1,789",
    },
  ];

  const asus: Product[] = [
    {
      id: 119,
      imgSrc: asus_default,
      title: 'Asus ProArt PX13 OLED HN7306E-ALX066WS 13.3" 3K Touch Laptop Nano Black ( AI MAX+ 395, 64GB, 1TB SSD, ATI, W11, HS+M365 )',
      price: "RM 11,349",
      badge: "New",
    },
    {
      id: 120,
      imgSrc: asus_default1,
      title: 'Asus VivoBook S 16 M3607G-ASH646WS 16" WUXGA OLED 60Hz Laptop Cool Silver ( Ryzen AI 7 445, 16GB, 512GB, ATI, W11, HS+M365 )',
      price: "RM 4,599",
      badge: "New",
    },
    {
      id: 121,
      imgSrc: asus_default2,
      title: 'Asus VivoBook S 16 M3607G-ASH645WS 16" WUXGA OLED 60Hz Laptop Matte Gray ( Ryzen AI 7 445, 16GB, 512GB, ATI, W11, HS+M365 )',
      price: "RM 4,599",
      badge: "New",
    },
    {
      id: 122,
      imgSrc: asus_default3,
      title: 'Asus Vivobook 16 M1607G-AMB445WS 16" WUXGA Laptop Quiet Blue ( Ryzen AI 7 445, 16GB, 1TB SSD, ATI, W11, HS+M365 )',
      price: "RM 4,209",
      badge: "New",
    },
    {
      id: 123,
      imgSrc: asus_default4,
      title: 'Asus Zenbook 14 UX3405C-AQL248WS 14" WUXGA OLED Laptop Ponder Blue ( CU5-225H, 16GB, 512B SSD, Intel Arc, W11, HS+M365 )',
      price: "RM 4,419",
      badge: "New",
    },
    {
      id: 124,
      imgSrc: asus_default5,
      title: 'Asus VivoBook Go 15 E1504F-ABQ052WS 15.6" FHD Laptop Green Grey ( R5 40, 16GB, 512GB SSD, ATI, W11, HS+M365 )',
      price: "RM 2,479",
      badge: "New",
    },
    {
      id: 125,
      imgSrc: asus_default6,
      title: 'Asus VivoBook Go 15 E1504F-ABQ050WS 15.6" FHD Laptop Mixed Black ( R5 40, 16GB, 512GB SSD, ATI, W11, HS+M365 )',
      price: "RM 2,479",
      badge: "New",
    },
    {
      id: 126,
      imgSrc: asus_default7,
      title: 'Asus ROG Flow Z13-KJP GZ302E-ACRU188W 13.4" 2.5K 180Hz Gaming Laptop ( AI MAX+ 395, 128GB, 1TB SSD, ATI, W11 )',
      price: "RM 17,329",
      badge: "On Sale",
    },
    {
      id: 127,
      imgSrc: asus_default8,
      title: 'Asus TUF Gaming A14 FA401E-ARG026W 14" 2.5K 165Hz Gaming Laptop ( AI MAX+ 392, 32GB, 1TB SSD, ATI, W11 )',
      price: "RM 7,299",
      badge: "On Sale",
    },
  ];

  const msi: Product[] = [
    {
      id: 128,
      imgSrc: msi_default,
      title: 'MSI Prestige 14 AI+ D3MG-064 14" FHD+ OLED Laptop Platinum Gray ( CU7-355, 32GB, 1TB SSD, Intel, W11, H&S )',
      price: "RM 5,899",
      badge: "Hot",
    },
    {
      id: 129,
      imgSrc: msi_default1,
      title: 'MSI Prestige 13 AI+ A3MG-034 13.3" 2.8K OLED Laptop Platinum Gray ( CU7-355, 32GB, 1TB SSD, Intel, W11, H&S )',
      price: "RM 6,299",
      badge: "Top Pick",
    },
    {
      id: 130,
      imgSrc: msi_default2,
      title: 'MSI Thin 15 B13UC-3456 15.6" FHD Gaming Laptop Cosmos Gray ( i5-13420H, 16GB, 512GB SSD, RTX3050 4GB, W11, HS+M365 )',
      price: "RM 3,579",
      badge: "On Sale",
    },
    {
      id: 131,
      imgSrc: msi_default3,
      title: 'MSI Thin 15 B13UC-3439 15.6" FHD Gaming Laptop Cosmos Gray ( i7-13620H, 16GB, 512GB SSD, RTX3050 4GB, W11, HS )',
      price: "RM 3,789",
    },
    {
      id: 132,
      imgSrc: msi_default4,
      title: 'MSI Thin 15 B13UC-3441 15.6" FHD Gaming Laptop Cosmos Gray ( i5-13420H, 16GB, 512GB SSD, RTX3050 4GB, W11 )',
      price: "RM 3,519",
    },
    {
      id: 133,
      imgSrc: msi_default5,
      title: '(AS New) MSI Thin A15 B7UC-204 15.6" FHD Gaming Laptop Cosmos Gray ( Ryzen 7 7735HS, 8GB D5, 512GB SSD, RTX3050 4GB, W11 )',
      price: "RM 3,259",
    },
    {
      id: 134,
      imgSrc: msi_default6,
      title: 'MSI Thin A15 B7UC-647 15.6" FHD Gaming Laptop Cosmos Gray ( R7-7735HS, 16GB D5, 1TB SSD, RTX3050 4GB, W11 )',
      price: "RM 3,889",
    },
    {
      id: 135,
      imgSrc: msi_default7,
      title: 'MSI Cyborg 15 B13WFKG-680 15.6" FHD Gaming Laptop ( i7-13620H, 16GB, 1TB SSD, RTX5060 8GB, W11 )',
      price: "RM 5,519",
    },
    {
      id: 136,
      imgSrc: msi_default8,
      title: 'MSI Cyborg 15 B13WFKG-680 15.6" FHD Gaming Laptop ( i7-13620H, 16GB, 1TB SSD, RTX5060 8GB, W11 )',
      price: "RM 4,679",
    },
  ];

  const hp: Product[] = [
    {
      id: 137,
      imgSrc: hp_default,
      title: 'HP OmniBook 7 AI 14-fr0070/0071/0072TU 14" 2K Laptop (CU7-255U, 16GB, 512GB SSD, Intel, W11, HS+M365)',
      price: "RM 4,449",
      badge: "New",
    },
    {
      id: 138,
      imgSrc: hp_default1,
      title: 'HP 15-fd2120TU 15.6" FHD Laptop Natural Silver ( CU7-255U, 16GB, 512GB SSD, Intel , W11, HS+M365 )',
      price: "RM 3,309",
    },
    {
      id: 139,
      imgSrc: hp_default2,
      title: 'HP 15-fd2119TU 15.6" FHD Laptop Moonlight Blue ( CU7-255U, 16GB, 512GB SSD, Intel , W11, HS+M365 )',
      price: "RM 3,309",
    },
    {
      id: 140,
      imgSrc: hp_default3,
      title: 'HP AI 15-fd2118TU 15.6" FHD Laptop Warm Gold ( CU7-255U, 16GB, 512GB SSD, Intel , W11, HS+M365 )',
      price: "RM 3,309",
    },
    {
      id: 141,
      imgSrc: hp_default4,
      title: 'HP PROBOOK 4 G1i-BV5X8PT 14" WUXGA Notebook AI Pike silver ( CU5 225U, 16GB, 512 GB SSD, Intel, W11P )',
      price: "RM 4,729",
      badge: "Hot",
    },
    {
      id: 142,
      imgSrc: hp_default5,
      title: 'HP 15-fd0907TU 15.6" FHD Laptop Natural Silver ( C5-120U, 16GB, 512GB SSD, Intel, W11, HS+M365 )',
      price: "RM 2,419",
    },
    {
      id: 143,
      imgSrc: hp_default6,
      title: 'HP 15-fd0906TU 15.6" FHD Laptop Moonlight Blue ( C5-120U, 16GB, 512GB SSD, Intel, W11, HS+M365 )',
      price: "RM 2,419",
      badge: "On Sale",
    },
    {
      id: 144,
      imgSrc: hp_default7,
      title: 'HP 15-fd0905TU 15.6" FHD Laptop Warm Gold ( C5-120U, 16GB, 512GB SSD, Intel, W11, HS+M365 )',
      price: "RM 2,419",
    },
    {
      id: 145,
      imgSrc: hp_default8,
      title: 'HP OmniBook 3 NGAI 14-ha0023AU 14" FHD Laptop Glacier Silver ( AI 5 330, 24GB, 512GB SSD, ATI, W11, HS+M365 )',
      price: "RM 2,949",
    },
  ];

  const dell: Product[] = [
    {
      id: 146,
      imgSrc: dell_default,
      title: 'Dell 14PRO PC14255-R7350-16G-512G-3YRS 14" FHD+ Laptop Silver ( AI 7-350, 16GB D5, 512GB SSD, ATI, W11P )',
      price: "RM 4,149",
    },
    {
      id: 147,
      imgSrc: dell_default1,
      title: 'Dell 14PRO PC14255-R5220-16G-512GB-3YRS 14" FHD+ Laptop Silver ( R5-220, 16GB D5, 512GB SSD, ATI, W11P )',
      price: "RM 3,419",
    },
    {
      id: 148,
      imgSrc: dell_default2,
      title: 'Dell 14PRO PV14250-C5120U-8G-512-W11PRO 14" FHD+ Laptop Black ( C5-120U, 8GB D5, 512GB SSD, Intel, W11P )',
      price: "RM 2,789",
    },
    {
      id: 149,
      imgSrc: dell_default3,
      title: '(AS NEW) Dell XPS14-9440-55165-RTX4050-W11PRO-2YRS 14.5" 3K OLED+ Laptop Silver ( CU7-165H, 16GB, 512GB, RTX4050 6GB , W11P )',
      price: "RM 6,829",
    },
    {
      id: 150,
      imgSrc: dell_default4,
      title: 'Dell Precision 3590 Workstation M3590-U7155H-16G-512GB 15.6" FHD IPS Laptop  ( CU7 155H, 16GB, 512GB, Intel, W11P )',
      price: "RM 4,519",
    },
    {
      id: 151,
      imgSrc: dell_default5,
      title: 'Dell 15 DC15255-R77730U-16GB-512GB-W11H 15.6" FHD IPS Laptop Platinum Silver ( R7 7730U, 16GB, 512GB, ATI, W11,HS+M365 )',
      price: "RM 2,679",
    },
    {
      id: 152,
      imgSrc: dell_default6,
      title: 'Dell 16 DC16250-C5120U-16GB-512GB-W11H 16" FHD 2K IPS Laptop Carbon Black ( C5-120U, 16GB, 512GB, Intel, W11,HS+M365 )',
      price: "RM 2,679",
    },
    {
      id: 153,
      imgSrc: dell_default7,
      title: 'Dell 16 DC16250-C7150U-16GB-1TB-W11H 16" FHD 2K IPS Laptop Carbon Black ( C7-150U, 16GB, 1TB, Intel, W11,HS+M365 )',
      price: "RM 3,259",
    },
    {
      id: 154,
      imgSrc: dell_default8,
      title: 'Dell PC14250-C7150U-16G-512GB 14" FHD+ Touch Laptop ( C7-150U, 16GB D5, 512GB SSD, Intel, W11P )',
      price: "RM 4,149",
    },
  ];

  const apple: Product[] = [
    {
      id: 155,
      imgSrc: apple_default,
      title: 'Apple MacBook Pro 14.2" Laptop ( Apple M4 Pro chip, 24GB, 512GB, MacOS ) MX2H3ZP, MX2E3ZP',
      price: "RM 8,249",
      badge: "Top Pick",
    },
    {
      id: 156,
      imgSrc: apple_default1,
      title: 'Apple MacBook Pro 16.2" Laptop ( Apple M4 Max chip, 48GB, 1TB, MacOS ) MX313ZP, MX2W3ZP',
      price: "RM 17,329",
    },
    {
      id: 157,
      imgSrc: apple_default2,
      title: 'Apple MacBook Pro 16.2" Laptop ( Apple M4 Pro chip, 24GB, 512GB, MacOS ) MX2X3ZP, MX2T3ZP',
      price: "RM 10,719",
    },
    {
      id: 158,
      imgSrc: apple_default3,
      title: 'Apple MacBook Air 15.3" Laptop ( Apple M3 chip, 16GB, 256GB, MacOS ) MC9D4ZP, MC9E4ZP',
      price: "RM 5,049",
      badge: "Hot",
    },
    {
      id: 159,
      imgSrc: apple_default4,
      title: 'Apple MacBook Air 13.6" Laptop ( Apple M4 chip, 16GB, 256GB, MacOS ) MC6T4ZP, MW0W3ZP, MW0Y3ZP, MW123ZP',
      price: "RM 4,309",
    },
    {
      id: 160,
      imgSrc: apple_default5,
      title: 'Apple iPad Air 11" Wi-Fi 512GB Gen 6 ( MCA94ZP, MCAE4ZP, MCAA4ZP, MCA74ZP ) - M3 Chip',
      price: "RM 3,999",
    },
    {
      id: 161,
      imgSrc: apple_default6,
      title: 'Apple iPad Air 11" Wi-Fi 256GB Gen 6 ( MCA34ZP, MCA64ZP, MCA44ZP, MCA14ZP ) - M3 Chip',
      price: "RM 3,049",
    },
    {
      id: 162,
      imgSrc: apple_default7,
      title: 'Apple iPad 11" Wi-Fi 256GB Gen 11 ( MD4G4ZP, MD4H4ZP, MD4J4ZP, MD4P4ZP ) - A16 Chip',
      price: "RM 1,899",
    },
    {
      id: 163,
      imgSrc: apple_default8,
      title: 'Apple iPad 11" Wi-Fi 128GB Gen 11 ( MD3Y4ZP, MD4A4ZP, MD4D4ZP, MD4E4ZP ) - A16 Chip',
      price: "RM 1,419",
    },
  ];

  const sections: BrandSection[] = [
    { key: "acer", title: "Acer", banner: acerBanner, products: acer },
    { key: "lenovo", title: "Lenovo", banner: lenovoBanner, products: lenovo },
    { key: "asus", title: "Asus", banner: asusBanner, products: asus },
    { key: "msi", title: "MSI", banner: msiBanner, products: msi },
    { key: "hp", title: "HP", banner: hpBanner, products: hp },
    { key: "dell", title: "Dell", banner: dellBanner, products: dell },
    { key: "apple", title: "Apple", banner: appleBanner, products: apple },
  ];

  

  return (
    <section className="home-content-1" id="featured-products">
      <div className="container">
        {sections.map((section, index) => (
          <BrandShowcase
            key={section.key}
            section={section}
            bannerLeft={index % 2 === 1}
            onAddToCart={handleAddToCart}
          />
        ))}
      </div>
      <button type="button" className="floating-cart-btn" onClick={() => navigate("/cart-summary")}>
        <i className="fa-solid fa-cart-shopping" aria-hidden="true"></i>
        <span className="floating-cart-label">Cart</span>

        {cartCount > 0 && <span className="floating-cart-count">{cartCount}</span>}
      </button>
    </section>
  );
}

export default HomeContent1;